import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ch0003',
    ecrans: ['00-2'],
    params: [
        'id'
    ]
});
